/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { InsuranceCompanyDetailsDtoOut } from '../model';
// @ts-ignore
import { OkResponse } from '../model';
// @ts-ignore
import { ReceiptOrderFormInfoDto } from '../model';
// @ts-ignore
import { RegistrationFormInfoDto } from '../model';
/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the newest doctor registration form information or default if no doctor registration form information exists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoDoctorRegistrationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/doctor-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set doctor registration form information.
         * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoDoctorRegistrationPost: async (registrationFormInfoDto?: RegistrationFormInfoDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/doctor-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationFormInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns list of all available insurance companies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoInsuranceCompaniesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/insurance-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the newest patient registration form information or default if no doctor registration form information exists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoPatientRegistrationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/patient-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set patient registration form information.
         * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoPatientRegistrationPost: async (registrationFormInfoDto?: RegistrationFormInfoDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/patient-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationFormInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns receipt order form information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoReceiptOrderGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/receipt-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set receipt order registration form information.
         * @param {ReceiptOrderFormInfoDto} [receiptOrderFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoReceiptOrderPost: async (receiptOrderFormInfoDto?: ReceiptOrderFormInfoDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-info/receipt-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receiptOrderFormInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the newest doctor registration form information or default if no doctor registration form information exists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoDoctorRegistrationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationFormInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoDoctorRegistrationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set doctor registration form information.
         * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoDoctorRegistrationPost(registrationFormInfoDto?: RegistrationFormInfoDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoDoctorRegistrationPost(registrationFormInfoDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns list of all available insurance companies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoInsuranceCompaniesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InsuranceCompanyDetailsDtoOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoInsuranceCompaniesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the newest patient registration form information or default if no doctor registration form information exists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoPatientRegistrationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationFormInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoPatientRegistrationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set patient registration form information.
         * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoPatientRegistrationPost(registrationFormInfoDto?: RegistrationFormInfoDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoPatientRegistrationPost(registrationFormInfoDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns receipt order form information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoReceiptOrderGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceiptOrderFormInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoReceiptOrderGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set receipt order registration form information.
         * @param {ReceiptOrderFormInfoDto} [receiptOrderFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormInfoReceiptOrderPost(receiptOrderFormInfoDto?: ReceiptOrderFormInfoDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormInfoReceiptOrderPost(receiptOrderFormInfoDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the newest doctor registration form information or default if no doctor registration form information exists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoDoctorRegistrationGet(options?: any): AxiosPromise<RegistrationFormInfoDto> {
            return localVarFp.apiFormInfoDoctorRegistrationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set doctor registration form information.
         * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoDoctorRegistrationPost(registrationFormInfoDto?: RegistrationFormInfoDto, options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiFormInfoDoctorRegistrationPost(registrationFormInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns list of all available insurance companies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoInsuranceCompaniesGet(options?: any): AxiosPromise<Array<InsuranceCompanyDetailsDtoOut>> {
            return localVarFp.apiFormInfoInsuranceCompaniesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the newest patient registration form information or default if no doctor registration form information exists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoPatientRegistrationGet(options?: any): AxiosPromise<RegistrationFormInfoDto> {
            return localVarFp.apiFormInfoPatientRegistrationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set patient registration form information.
         * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoPatientRegistrationPost(registrationFormInfoDto?: RegistrationFormInfoDto, options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiFormInfoPatientRegistrationPost(registrationFormInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns receipt order form information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoReceiptOrderGet(options?: any): AxiosPromise<ReceiptOrderFormInfoDto> {
            return localVarFp.apiFormInfoReceiptOrderGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set receipt order registration form information.
         * @param {ReceiptOrderFormInfoDto} [receiptOrderFormInfoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormInfoReceiptOrderPost(receiptOrderFormInfoDto?: ReceiptOrderFormInfoDto, options?: any): AxiosPromise<OkResponse> {
            return localVarFp.apiFormInfoReceiptOrderPost(receiptOrderFormInfoDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
    /**
     * 
     * @summary Returns the newest doctor registration form information or default if no doctor registration form information exists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoDoctorRegistrationGet(options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoDoctorRegistrationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set doctor registration form information.
     * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoDoctorRegistrationPost(registrationFormInfoDto?: RegistrationFormInfoDto, options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoDoctorRegistrationPost(registrationFormInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns list of all available insurance companies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoInsuranceCompaniesGet(options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoInsuranceCompaniesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the newest patient registration form information or default if no doctor registration form information exists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoPatientRegistrationGet(options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoPatientRegistrationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set patient registration form information.
     * @param {RegistrationFormInfoDto} [registrationFormInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoPatientRegistrationPost(registrationFormInfoDto?: RegistrationFormInfoDto, options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoPatientRegistrationPost(registrationFormInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns receipt order form information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoReceiptOrderGet(options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoReceiptOrderGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set receipt order registration form information.
     * @param {ReceiptOrderFormInfoDto} [receiptOrderFormInfoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public apiFormInfoReceiptOrderPost(receiptOrderFormInfoDto?: ReceiptOrderFormInfoDto, options?: any) {
        return FormsApiFp(this.configuration).apiFormInfoReceiptOrderPost(receiptOrderFormInfoDto, options).then((request) => request(this.axios, this.basePath));
    }
}
